import { render, staticRenderFns } from "./BackhaulTable.vue?vue&type=template&id=6aeba7a5"
import script from "./BackhaulTable.vue?vue&type=script&lang=js"
export * from "./BackhaulTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports